/* eslint-disable react/prop-types */ // TODO: add props
import { QUESTION_GROKKED, QUESTION_GROKKED_LABEL } from 'edrolo/domains/exams';
import C3Chart from 'edrolo-style-guide/components/C3Chart';
import Legend from './Legend';
import styles from './styles.scss';

const colors = {
  'Understands': '#A8CB8C',
  'Needs help': '#EE7860',
  'Not reflected': '#dfdddd',
};

const getToolTipHTML = (dataPoints) => {
  return dataPoints
    .filter((d) => d.value > 0)
    .map(({ name, value }) => {
      return `
        <div id="tooltip-legend" style="background:${colors[name]};"></div>
        <span>${name}: ${value}</span>`;
    });
};

export const StackedBarChartMultiSelect = ({
  question,
  solution,
  profileQuestionResponseSummary,
}) => {
  if (!question || !solution || !profileQuestionResponseSummary) {
    return <p>No Data</p>;
  }

  const answerOptions = {
    'CORRECT': {
      [QUESTION_GROKKED_LABEL.UNDERSTANDS]: [],
      [QUESTION_GROKKED_LABEL.NEEDS_HELP]: [],
      [QUESTION_GROKKED_LABEL.NOT_REFLECTED]: [],
    },
    'INCORRECT': {
      [QUESTION_GROKKED_LABEL.UNDERSTANDS]: [],
      [QUESTION_GROKKED_LABEL.NEEDS_HELP]: [],
      [QUESTION_GROKKED_LABEL.NOT_REFLECTED]: [],
    },
  };

  profileQuestionResponseSummary.forEach((row) => {
    switch (row.get('grokked')) {
      case QUESTION_GROKKED.YES: {
        row.get('correct')
          ? answerOptions.CORRECT[QUESTION_GROKKED_LABEL.UNDERSTANDS].push(
              row.get('userProfileId')
            )
          : answerOptions.INCORRECT[QUESTION_GROKKED_LABEL.UNDERSTANDS].push(
              row.get('userProfileId')
            );
        break;
      }

      case QUESTION_GROKKED.NO: {
        row.get('correct')
          ? answerOptions.CORRECT[QUESTION_GROKKED_LABEL.NEEDS_HELP].push(
              row.get('userProfileId')
            )
          : answerOptions.INCORRECT[QUESTION_GROKKED_LABEL.NEEDS_HELP].push(
              row.get('userProfileId')
            );
        break;
      }

      case QUESTION_GROKKED.NO_RESPONSE: {
        row.get('correct')
          ? answerOptions.CORRECT[QUESTION_GROKKED_LABEL.NOT_REFLECTED].push(
              row.get('userProfileId')
            )
          : answerOptions.INCORRECT[QUESTION_GROKKED_LABEL.NOT_REFLECTED].push(
              row.get('userProfileId')
            );
        break;
      }

      default:
        break;
    }
  });

  const min = 0;
  const max = profileQuestionResponseSummary.size;
  const height = 180;
  const width = 366;

  const data = {
    columns: [
      [
        QUESTION_GROKKED_LABEL.UNDERSTANDS,
        answerOptions.CORRECT[QUESTION_GROKKED_LABEL.UNDERSTANDS].length,
        answerOptions.INCORRECT[QUESTION_GROKKED_LABEL.UNDERSTANDS].length,
      ],
      [
        QUESTION_GROKKED_LABEL.NEEDS_HELP,
        answerOptions.CORRECT[QUESTION_GROKKED_LABEL.NEEDS_HELP].length,
        answerOptions.INCORRECT[QUESTION_GROKKED_LABEL.NEEDS_HELP].length,
      ],
      [
        QUESTION_GROKKED_LABEL.NOT_REFLECTED,
        answerOptions.CORRECT[QUESTION_GROKKED_LABEL.NOT_REFLECTED].length,
        answerOptions.INCORRECT[QUESTION_GROKKED_LABEL.NOT_REFLECTED].length,
      ],
    ],
    type: 'bar',
    colors,
    groups: [['Understands', 'Needs help', 'Not reflected']],
    labels: {
      format: {
        'Understands': (v, id, i, j) => (i === 0 && v ? `✔` : ''),
      },
    },
  };

  const options = {
    axis: {
      x: {
        type: 'category',
        categories: Object.keys(answerOptions),
        tick: {
          outer: false,
        },
      },
      y: {
        min,
        max,
        padding: {
          bottom: 0,
          top: 50, // leave room for the checkmark above correct bar if all students got the question correct.
        },
        tick: {
          values: [min, Math.floor(max / 2), max],
          outer: false,
        },
      },
    },

    grid: {
      y: {
        lines: [{ value: 0 }],
      },
    },

    size: {
      height,
      width,
    },

    legend: {
      show: false,
    },

    tooltip: {
      show: true,
      position: function (data, width, height, element) {
        return {
          top: 0,
          left: 250,
        };
      },
      grouped: true,
      horizontal: false,
      contents: function (dataPoints) {
        return getToolTipHTML(dataPoints);
      },
    },
  };

  return (
    <div className={styles.container}>
      <p className={styles.chartYAxisLabel}>No. of students</p>
      <C3Chart
        data={data}
        options={options}
        className={styles.chartContainer}
      />
      <Legend />
    </div>
  );
};
